import { type LucideIcon, Moon, Sun } from 'lucide-react'

/** shared by the settings page and the command-palette section so a future
 * third option lands in one place. system was dropped because the page
 * background paint runs before next-themes resolves it. */
export type ThemeOption = {
  value: 'light' | 'dark'
  label: string
  icon: LucideIcon
}

export const THEME_OPTIONS: readonly ThemeOption[] = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon }
] as const
